import BusinessHours from './_content/BusinessHours';
import Career from './_content/Career';
import Cookie from './_content/Cookie';
import Parking from './_content/Parking';
import RentingSpaces from './_content/RentingSpaces';
import VisitorPolicy from './_content/VisitorPolicy';

type LanguageObject = {
	[key: string]: string;
};

export interface IContent {
	title: LanguageObject;
	description?: LanguageObject;
	content: LanguageObject;
	slug: LanguageObject;
}

export interface RentingSpacesTablesDataFragment {
	id: string;
	title: Record<string, string>;
	description?: Record<string, string>;
	/** Photo paths relative to public/, the first one is used as the preview */
	images?: string[];
	/** Floor label, e.g. '1. poschodie' */
	floor?: Record<string, string>;
	/** Area in m² */
	area: number;
	/** Monthly rent in € per m², excl. VAT */
	rentPerM2: number;
	/** Monthly energies and services in € per m², excl. VAT */
	energyPerM2: number;
	/** Monthly other services in € per m², excl. VAT */
	otherServicesPerM2: number;
}

const codelist: Record<string, IContent> = {
	visitorPolicy: VisitorPolicy,
	parking: Parking,
	businessHours: BusinessHours,
	rentingSpaces: RentingSpaces,
	career: Career,
	cookie: Cookie
};

export default codelist;
